import { render, staticRenderFns } from "./aftTheSoftware.vue?vue&type=template&id=4993a880&scoped=true&"
import script from "./aftTheSoftware.vue?vue&type=script&lang=js&"
export * from "./aftTheSoftware.vue?vue&type=script&lang=js&"
import style0 from "./aftTheSoftware.vue?vue&type=style&index=0&id=4993a880&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993a880",
  null
  
)

export default component.exports